import { render, staticRenderFns } from "./DialogFormActivityTypeAdd.vue?vue&type=template&id=3a5c6195"
import script from "./DialogFormActivityTypeAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormActivityTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports